import { useState, useEffect } from "react";
import { getSenatorList, getRegions } from "../../../../api/ph-api";
import { SeoTag, CxenseParseTag } from "../../../../../components/seo/SeoTag";
import RacesPage from "../../../../../components/races/RacesPage";

export const getStaticProps = async () => {
  let regionList = await getRegions();
  let senatorialList = await getSenatorList();

  if (!senatorialList || !regionList) {
    return {
      props: { senatorialList, regionList },
      revalidate: 5
    }
  }

  return {
    props: { senatorialList, regionList },
  };
};

const SenatorialOAVRes = ({ senatorialList, regionList }) => {
  const [url, setUrl] = useState("");
  const title =
    "PARTIAL, UNOFFICIAL: 2022 senatorial election results | overseas absentee voting | Philippines";
  const description =
    "This page shows partial, unofficial, overseas absentee voting results for senator based from the Comelec transparency server after polls closed on May 9, 2022. The percentage of votes received is computed based on the total number of actual voters in each contest.";
  const keywords =
    "2022 Philippine elections, #PHVote, Philippine elections, senatorial candidates philippines, election results Philippines, election results Philippines";
  const og_image = "https://www.rappler.com/tachyon/2022/03/ATIN-PILIPINAS.jpg";

  let twitter_title;
  useEffect(() => {
    setUrl(window.location.href);
    twitter_title = `#PHVoteResults: 2022 PH election overseas voting results for senator  #PHVote #WeDecide ${window.location.href}`;
  }, []);

  return (
    <>
      <SeoTag
        title={title}
        description={description}
        keywords={keywords}
        og_image={og_image}
        twitter_og_image={og_image}
        twitter_title={twitter_title}
        twitter_description={description}
      />
      <CxenseParseTag title={title} />
      <RacesPage view="overseas-absentee-voting-results" path="senator" senatorialList={senatorialList} regionList={regionList} url={url} />;
    </>
  );
};

export default SenatorialOAVRes;
